import Vue from "vue";
import Vuex from "vuex";
import AWN from "awesome-notifications";
import axios from "axios";
import moment from "moment";
import { set } from "vue/types/umd";

Vue.use(Vuex);

const PouchDB = require("pouchdb").default;

export default new Vuex.Store({
  state: {
    userProfile: { isFieldWorker: true },
    notifier: null,
    enableOfflineApplications: false,
    csAppsOfflineMode: false,
    offlineApplicationsData: [],
    newOfflineApplicationsData: [],
    offlineReadingsData: [],
    offlineConnectionsSpHeaders: {},
    selectedOfflineAppId: 0,
    csLocalDB: null,
    readingsLocalDB: null,
    debtManagementLocalDB: null,
    isFieldWorker: true,
    hierarchyLinksLoaded: false,
    hierarchyLinks: [],
    hierarchyLinksTreeOptions: {},
    empScheduleLookups: null,
    supportServicesScheduleLookups: null,
    elementTypesPlain: [],
    settings: {
      isValid: false,
      dmSettings: {},
    }, //Utility/GetSettings
    captureReadingsCommonData: {},
    captureReadingsSpotBillReports: [],
    captureMeterReadingsSearch: {
      offlineSearchType: "",
      offlineSearchText: "",
    },
    dmRecordsSearch: { offlineSearchType: "", offlineSearchText: "" },
    dateFormat: "DD/MM/yyyy",
    materialDateFormat: "dd/MM/yyyy",
    orgPosts: [],
    editReadingActiveRecord: {},
    cmrBulkMeter: {},
    dmSelectionSettings: {},
    enqCustomerDisplayData: null,
    isPostEditableAttachmentsActivity: false,
    userStations: {
      assigned: { id: -1, name: "" },
      declared: { id: -1, name: "" },
    },
    disableLoginButton: {
      text: null,
      date: null,
      disabled: true,
      description: "",
    },
    isInIframe: false,
    jwtToken: "",
    currAppIdOpened: null,
  },
  mutations: {
    setCurrAppIdOpened(state, payload) {
      state.currAppIdOpened = payload;
    },
    setJwtToken(state, payload) {
      state.jwtToken = payload;
    },
    setIsInIframe(state, payload) {
      state.isInIframe = payload;
    },
    setOrgPosts(state, payload) {
      if (payload == null) state.orgPosts = [];
      else state.orgPosts = payload;
    },
    setCaptureMeterReadingsSearch(state, payload) {
      state.captureMeterReadingsSearch = payload;
    },
    setDmRecordsSearch(state, payload) {
      state.dmRecordsSearch = payload;
    },
    setUserProfile(state, payload) {
      state.userProfile = payload;
    },
    initNotifier(state, payload) {
      state.notifier = new AWN(payload.options);
    },
    initCsPouchDB(state) {
      state.csLocalDB = new PouchDB("CSLocalDB");
    },
    initReadingsPouchDB(state) {
      state.readingsLocalDB = new PouchDB("ReadingsLocalDB", { size: 500 });
      console.log("PouchDB ReadingsLocalDB Initiate");
    },
    initDebtManagementLocalDB(state) {
      state.debtManagementLocalDB = new PouchDB(
        "DebtManagementLocalDBLocalDB",
        { size: 500 }
      );
      console.log("PouchDB DebtManagementLocalDB Initiate");
    },
    setDebtManagement(state, payload) {
      state.debtManagementLocalDB = payload.data;
    },
    setOfflineApplicationsData(state, payload) {
      state.offlineApplicationsData = payload.data;
    },
    setNewOfflineApplicationsData(state, payload) {
      state.newOfflineApplicationsData = payload;
    },
    selectOfflineApplication(state, payload) {
      state.selectedOfflineAppId = payload.appId;
    },
    setEnableOfflineApplications(state, payload) {
      state.enableOfflineApplications = payload;
    },
    setIsFieldWorker(state, payload) {
      state.isFieldWorker = payload;
    },
    setHierarchyLinks(state, payload) {
      state.hierarchyLinks = payload.links;
      state.hierarchyLinksTreeOptions = payload.options;
      state.hierarchyLinksLoaded = true;
    },
    setEmpScheduleLookups(state, payload) {
      state.empScheduleLookups = payload;
    },
    setSupportServicesScheduleLookups(state, payload) {
      state.supportServicesScheduleLookups = payload;
    },
    setOfflineReadingsData(state, payload) {
      state.offlineReadingsData = payload.data;
    },
    setSettings(state, payload) {
      state.settings = payload.data;
    },
    setCaptureReadingsCommonData(state, payload) {
      state.captureReadingsCommonData = payload.data;
    },
    setCaptureReadingsSpotBillReports(state, payload) {
      state.captureReadingsSpotBillReports = payload.items;
    },
    setOfflineConnectionsSpHeaders(state, payload) {
      state.offlineConnectionsSpHeaders = payload.data;
    },
    setElementTypesPlain(state, payload) {
      state.elementTypesPlain = payload;
    },
    setCsAppsOfflineMode(state, payload) {
      state.csAppsOfflineMode = payload.status;
    },
    setDateFormat(state, payload) {
      state.dateFormat = payload;
    },
    setMaterialDateFormat(state, payload) {
      state.materialDateFormat = payload;
    },
    setEditReadingActiveRecord(state, payload) {
      state.editReadingActiveRecord = payload;
    },
    setCmrBulkMeter(state, payload) {
      state.cmrBulkMeter = payload;
    },
    setEnqCustomerDisplayData(state, payload) {
      state.enqCustomerDisplayData = payload;
    },
    setIsPostEditableAttachmentsActivity(state, payload) {
      state.isPostEditableAttachmentsActivity = payload;
    },
    setUserStations(state, payload) {
      state.userStations = payload;
    },
    setDisableLoginButtonDate(state, date) {
      if (date && moment(date).isSameOrAfter(moment())) {
        state.disableLoginButton.date = date;
        state.disableLoginButton.disabled = true;
      } else state.disableLoginButton.disabled = false;
    },
    setDisableLoginButtonDescription(state, payload) {
      state.disableLoginButton.description = payload;
    },
    setDisableLoginButtonText(state, payload) {
      state.disableLoginButton.text = payload;
    },
  },
  getters: {
    getCurrentAppIdOpened(state) {
      return state.currAppIdOpened;
    },
    getJwtToken(state) {
      return state.jwtToken;
    },
    getIsInIframe(state) {
      return state.isInIframe;
    },
    getCsAppsOfflineMode(state) {
      return state.csAppsOfflineMode;
    },
    getDateFormat(state) {
      return state.dateFormat;
    },
    getMaterialDateFormat(state) {
      return state.materialDateFormat;
    },
    getOrgPosts(state) {
      return state.orgPosts;
    },
    getUserProfile(state) {
      return state.userProfile;
    },
    getIsFieldWorker(state) {
      return state.userProfile && state.userProfile.isFieldWorker === true;
    },
    getEditReadingActiveRecord(state) {
      return state.editReadingActiveRecord;
    },
    getCmrBulkMeter(state) {
      return state.cmrBulkMeter;
    },
    getDmSettings(state) {
      return state.settings && state.settings.dmSettings
        ? state.settings.dmSettings
        : null;
    },
    getDmSelectionSettings(state) {
      return state.dmSelectionSettings;
    },
    getSettings(state) {
      return state.settings;
    },
    getEnqCustomerDisplayData(state) {
      return state.enqCustomerDisplayData;
    },
    getIsPostEditableAttachmentsActivity(state) {
      return state.isPostEditableAttachmentsActivity;
    },
    getUserStations(state) {
      return state.userStations;
    },
    getDisableLoginButton(state) {
      return state.disableLoginButton;
    },
  },
  actions: {
    async resetReadingsLocalDB({ commit, state }) {
      console.log(state.readingsLocalDB);
      await state.readingsLocalDB.destroy((err, response) => {
        if (err) console.log("PouchDB ReadingsLocalDB Destoy Error: ", err);
        else console.log("PouchDB ReadingsLocalDB Destoyed");
      });
      await commit("initReadingsPouchDB");
    },
    async resetDebtManagementLocalDB({ commit, state }) {
      await state.debtManagementLocalDB.destroy((err, response) => {
        if (err)
          console.log("PouchDB DebtManagementLocalDB Destoy Error: ", err);
        else console.log("PouchDB DebtManagementLocalDB Destoyed");
      });
      await commit("initDebtManagementLocalDB");
    },
    getUtilitySettings({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.settings.isValid == false) {
          //get settings
          axios
            .post("/Utility/GetSettings")
            .then((response) => {
              if (response.data.data.status == 0) {
                response.data.value.isValid = true;

                response.data.value["dmSettings"] = {
                  showAccountInfo:
                    response.data.value.dmShowAccountInfo == true,
                  showTenantName: response.data.value.dmShowTenantName == true,
                  showConsumerType:
                    response.data.value.dmShowConsumerType == true,
                  showPropertyRef:
                    response.data.value.dmShowPropertyRef == true,
                  showConsumptionType:
                    response.data.value.dmShowConsumptionType == true,
                  showCellPhoneNumber:
                    response.data.value.dmShowCellPhoneNumber == true,
                  showPhoneNumber:
                    response.data.value.dmShowPhoneNumber == true,
                  showBalance: response.data.value.dmShowBalance == true,
                };

                delete response.data.value.dmShowAccountInfo;
                delete response.data.value.dmShowTenantName;
                delete response.data.value.dmShowConsumerType;
                delete response.data.value.dmShowPropertyRef;
                delete response.data.value.dmShowConsumptionType;
                delete response.data.value.dmShowCellPhoneNumber;
                delete response.data.value.dmShowPhoneNumber;
                delete response.data.value.dmShowBalance;

                commit("setSettings", { data: response.data.value });
              }
            })
            .catch((err) =>
              commit("setSettings", { isValid: false, error: err })
            )
            .finally(() => resolve(state.settings));
        } else resolve(state.settings);
      });
    },
    setDmSelectionSettings({ state }, payload) {
      if (!payload) return;

      if (payload.reset == true) state.dmSelectionSettings = {};
      else
        Object.keys(payload).forEach(
          (key) => (state.dmSelectionSettings[key] = payload[key])
        );
    },
  },
});
